import React from "react";

import "./Loader.css";

class Loader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render = () => {
    return (
      <div className="loader-container">
        <img src={"/socacon-27.png"} alt="Icon Loader" style={{ width: "325px" }} />
      </div>
    );
  };
}

export default Loader;
